export const PREVIEW_BUTTON_TEXT = {
  PREPARE_PREVIEW: "Prepare Preview",
  PREVIEW: "Preview",
  PREPARING_PREVIEW: "Preparing preview..."
};

export const PREVIEW_TOOLTIP = {
  NO_CHANGES: "No changes were submitted",
  BUILD_NEEDED: "Build the agent to preview it",
  PREPARING_PREVIEW: "Preparing your preview",
  NOT_PREVIEWABLE: "Preview is only available \n after your first publish"
};
